// extracted by mini-css-extract-plugin
export default {"slider":"slider-module__slider--par","thumb":"slider-module__thumb--w51"};